import { XGSSelectOption } from "../../../ui-components/xgs-select/xgsSelect";
import { validationMessages } from "../common/validationMessages";
import * as Yup from "yup";

export interface Address {
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    country: string | null ;
    mailingAddress: string | null;
    mailingCity: string | null;
    mailingStateProvince: string | null;
    mailingZipPostalCode: string | null;
    mailingCountry: string | null;
    isMailingAddressSame: boolean;
}

export interface TerminalInfoSettings {
    hub: string | null;
    hubNumber: string | null;
    ratingZone: string | null;
    tcgTerminalNumber: string | null;
    dailyPickups: boolean,
    ricControl: boolean,
    wmsReceipt: boolean,
    dvirInspection: boolean,
    allowPickupRoute: boolean,
    fourBySixLabels: boolean,
    vmuUsage: boolean,
    agentTerminal: boolean,
    rlmTerminal: boolean,
    companyFacility: boolean,
    bondedFacility: boolean,
    physicalLocation: boolean,
    reportingFacility: boolean,
    originFlag: boolean,
    destinationFlag: boolean,
    barcodeFlag: boolean,
    excludeFromWeb: boolean,
}

export interface ExecutiveContact {
    executiveName: string | null;
    executivePhone: string | null;
    executiveEmail: string | null;
}

export interface AgentAddress {
    agentAddress: string | null;
    agCity: string | null;
    agState: string | null;
}

export interface Contact {
    phoneNumber: string | null;
    terminalEmail: string;
    managerName: string | null;
    managerEmail: string | null;
    managerPhone: string | null;
    agentName: string | null;
    agentEmail: string | null;
    agentPhone: string | null;
    agentAddress: string | null;
    agCity: string | null;
    agState: string | null;
}

export interface Region {
    regionName: string | null;
    vpName: string | null;
    vpPhone: string | null;
    vpEmail: string | null;
    directorName: string | null;
    directorPhone: string | null;
    directorEmail: string | null;
}

export interface BasicInfo {
    terminalNumber: string | null;
    terminalType: string | null;
    division: string | null;
    timezone: string | null;
    airportCode: string | null;
    status: string | null;
    region?: string | null;
    wmsWarehousing: string | boolean | null;
    terminalName?: string | null;
    operationOpenHours?: string | null;
    willCallOpenHours?: string | null;
    operationFromTime?: string | null;
    operationToTime?: string | null;
    willCallFromTime?: string | null;
    willCallToTime?: string | null;
}

export interface AddTerminal extends BasicInfo, Address, Region, Contact, AgentAddress{
    
}

export interface UpdateBasicInfo {
    terminalType: string | null;
    division: string | null;
    timezone: string | null;
    airportCode: string | null;
    status: string | null;
    regionName: string | null;
    warehouse: boolean | null;
    operationDays: string | null;
    operationFromTime: string | null;
    operationToTime: string | null;
    willCallDays: string | null;
    willCallFromTime: string | null;
    willCallToTime: string | null;
}

export interface UpdateStatus {
    status: 'ACTIVE' | 'INACTIVE' | null;
}

export interface UpdateHoursOfOperation {
    operationOpenHours: string | null,
    willCallOpenHours: string | null,
    operationFromTime: string | null,
    operationToTime: string | null,
    willCallFromTime: string | null,
    willCallToTime: string | null,
}

export interface DeleteTerminalModel {
    terminalNumber: number;
}

export interface TerminalRequestModel {
    terminalName: string | null,
    terminalNumber?: string | null,
    terminalType: string | null,
    airportCode: string | null,
    status: string | null,
    division: string | null,
    timezone: string | null,
    warehouse: boolean,
    operationDays: string | null,
    operationFromTime: string | null,
    operationToTime: string | null,
    willCallDays: string | null,
    willCallFromTime: string | null,
    willCallToTime: string | null,
    address: {
        physicalAddress: string | null,
        city: string | null,
        stateProvince: string | null,
        zipPostalCode: string | null,
        country: string | null,
        isMailingAddressSame: boolean,
        mailingAddress: string | null,
        mailingCity: string | null,
        mailingStateProvince: string | null,
        mailingZipPostalCode: string | null,
        mailingCountry: string | null
    },
    contact: {
        phoneNumber: string | null,
        terminalEmail: string | null,
        managerName: string | null,
        managerEmail: string | null,
        managerPhone: string | null,
        agentName: string | null,
        agentEmail: string | null,
        agentPhone: string | null,
        agentAddress: string | null,
        agCity: string | null,
        agState: string | null
    },
    region: {
        regionName: string | null,
        vpName: string | null,
        vpPhone: string | null,
        vpEmail: string | null,
        directorName: string | null,
        directorPhone: string | null,
        directorEmail: string | null
    }

}

interface TerminalTypeModel {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userCreated: string;
    userUpdated: string;
    type: string;
    description: string;
}

interface AddressModel {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userCreated: string;
    userUpdated: string;
    physicalAddress: string;
    city: string;
    stateProvince: string;
    zipPostalCode: string;
    country: string;
    isMailingAddressSame: boolean;
    mailingAddress: string | null;
    mailingCity: string | null;
    mailingStateProvince: string | null;
    mailingZipPostalCode: string | null;
    mailingCountry: string | null;
}

interface ContactModel {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userCreated: string;
    userUpdated: string;
    phoneNumber: string | null;
    terminalEmail: string;
    managerName: string;
    managerEmail: string;
    managerPhone: string | null;
    agentName: string | null;
    agentEmail: string | null;
    agentPhone: string | null;
    agentAddress: string | null;
    agCity: string | null;
    agState: string | null;
}

interface RegionModel {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userCreated: string;
    userUpdated: string;
    regionName: string | null;
    vpName: string | null;
    vpPhone: string | null;
    vpEmail: string | null;
    directorName: string | null;
    directorPhone: string | null;
    directorEmail: string | null;
}

interface TerminalOpenHoursModel {
    id: string;
    dateCreated: string;
    dateUpdated: string;
    userCreated: string;
    userUpdated: string;
    fromTime: string | null;
    toTime: string | null;
    openDays: string | null;
    openHours: string | null;
    type: string;
    terminalNumber: number;
}

export interface TerminalResponseModel {
    terminalNumber: number | null;
    terminalName: string;
    airportCode: string | null;
    status: string;
    division: string;
    warehouse: boolean;
    timezone: string;
    userCreated: string | null;
    userUpdated: string;
    dateCreated: string;
    dateUpdated: string;
    updatedBy: string;
    terminalType: TerminalTypeModel;
    address: AddressModel;
    contact: ContactModel;
    region: RegionModel;
    terminalOpenHoursList: TerminalOpenHoursModel[];

}

export interface UpdateAddress {
    id?: string,
    physicalAddress: string | null,
    city: string | null,
    stateProvince: string | null,
    zipPostalCode: string | null,
    country: string | null,
    isMailingAddressSame: boolean,
    mailingAddress?: string | null,
    mailingCity?: string | null,
    mailingStateProvince?: string | null,
    mailingZipPostalCode?: string | null,
    mailingCountry?: string | null
}

export interface UpdateContact {
    id?: string,
    phoneNumber: string | null,
    terminalEmail: string | null,
    managerName: string | null,
    managerEmail: string | null,
    managerPhone: string | null,
    agentName: string | null,
    agentEmail: string | null,
    agentPhone: string | null,
    agentAddress: string | null,
    agCity: string | null,
    agState: string | null,
}

export interface UpdateRegion {
    id?: string,
    regionName: string | null,
    vpName: string | null,
    vpPhone: string | null,
    vpEmail: string | null,
    directorName: string | null,
    directorPhone: string | null,
    directorEmail: string | null
}

export interface AdditionalSettings {
    dailyPickups: boolean,
    ricControl: boolean,
    wmsReceipt: boolean,
    dvirInspection: boolean,
    allowPickupRoute: boolean,
    fourBySixLabels: boolean,
    vmuUsage: boolean,
    agentTerminal: boolean,
    rlmTerminal: boolean,
    companyFacility: boolean,
    bondedFacility: boolean,
    physicalLocation: boolean,
    reportingFacility: boolean,
    originFlag: boolean,
    destinationFlag: boolean,
    barcodeFlag: boolean,
    excludeFromWeb: boolean,
    hub: string | null,
    hubNumber: string | null,
    ratingZone: string | null,
    tcgTerminalNumber: string | null
}
export interface TerminalLogItem {
    changedAt: string;
    modifiedBy: string;
    changeDescription: string;
    action: "UPDATE" | "DELETE" | "CREATE";
}

export interface TerminalLogFilterModel {
    dateFrom?: string;
    dateTo?: string;
}

export const TerminalLogFilterSchema: Yup.ObjectSchema<TerminalLogFilterModel> = Yup.object({
    dateFrom: Yup.string(),
    dateTo: Yup.string(),
}).defined();

export const getAddressValidation = () => {
    return Yup.object({
        street: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters").required(validationMessages.required),
        city: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
        state: Yup.string().required(validationMessages.required),
        zip: Yup.string().matches(/^\d*$/, validationMessages.notValid).min(5, "The value must be no less than 5 digits").max(5, "The value must be no more than 5 digits").required(validationMessages.required),
        country: Yup.string().required(validationMessages.required),
        mailingAddress: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters").required(validationMessages.required),
        mailingCity: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
        mailingStateProvince: Yup.string().required(validationMessages.required),
        mailingZipPostalCode: Yup.string().matches(/^\d*$/, validationMessages.notValid).min(5, "The value must be no less than 5 digits").max(5, "The value must be no more than 5 digits").required(validationMessages.required),
        mailingCountry: Yup.string().required(validationMessages.required)
    })
}

export const getPhysicalAddressValidation = () => {
    return Yup.object({
        street: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters").required(validationMessages.required),
        city: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
        state: Yup.string().required(validationMessages.required),
        zip: Yup.string().matches(/^\d*$/, validationMessages.notValid).min(5, "The value must be no less than 5 digits").max(5, "The value must be no more than 5 digits").required(validationMessages.required),
        country: Yup.string().required(validationMessages.required),
    })
}

export const getAdditionalSettingsValidation = () => {
    return Yup.object({
        hub: Yup.string().matches(/\S+/, validationMessages.notValid).nullable(),
        hubNumber: Yup.string().matches(/^\d*$/, validationMessages.notValid).nullable(),
        ratingZone: Yup.string().matches(/^\d*$/, validationMessages.notValid).nullable(),
        tcgTerminalNumber: Yup.string().matches(/^\d*$/, validationMessages.notValid).nullable(),
    })
}

export const getAgentAddressValidation = () => {
    return Yup.object({
        physicalAddress: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters"),
    })
}

export const getExecutiveContactValidation = () => {
    return Yup.object({
        executiveName: Yup.string().required(validationMessages.required).matches(/\S+/, validationMessages.notValid).max(128, "Maximum 128 characters"),
        executivePhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid).required(validationMessages.required),
        executiveEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid).required(validationMessages.required),
    })
}

export const getExecutiveContactValidationWithoutRequired = () => {
    return Yup.object({
        executiveName: Yup.string().matches(/\S+/, validationMessages.notValid).max(128, "Maximum 128 characters"),
        executivePhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid),
        executiveEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid),
    })
}

export const getContactValidation = () => {
    return Yup.object({
        phoneNumber: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid).required(validationMessages.required),
        terminalEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid).required(validationMessages.required),
        managerName: Yup.string().required(validationMessages.required).matches(/\S+/, validationMessages.notValid).max(128, "Maximum 128 characters"),
        managerPhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid).required(validationMessages.required),
        managerEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid).required(validationMessages.required),
        agentName: Yup.string().matches(/\S+/, validationMessages.notValid).max(128, "Maximum 128 characters"),
        agentPhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid),
        agentEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid),
        agentAddress: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters"),
        agCity: Yup.string().max(64, "The value must be no more than 64 characters"),
        agState: Yup.string(),
    })
}


export const getRegionValidationForAddTerminal = () => {
    return Yup.object({
        regionName: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        vpName: Yup.string().max(128, "Maximum 128 characters"),
        vpPhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid),
        vpEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid),
        directorName: Yup.string().max(128, "Maximum 128 characters"),
        directorPhone: Yup.string().matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid),
        directorEmail: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid),
    })
}

export const getBasicInfoValidation = () => {
    return Yup.object({
        terminalType: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        division: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        timezone: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        airportCode: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        status: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        region: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        wmsWarehousing: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
    })
}


export const getBasicInfoValidationForEdit = () => {
    return Yup.object({
        terminalName: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        terminalType: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        division: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        timezone: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        airportCode: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        wmsWarehousing: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
    })
}

export const validationSchema = Yup.object({
    ...getBasicInfoValidationForEdit().fields,
    ...getAddressValidation().fields,
    ...getContactValidation().fields,
    ...getRegionValidationForAddTerminal().fields,
});

export const getHoursOfOperationValidation = () => {
    return Yup.object({
        operationOpenHours: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        willCallOpenHours: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        operationOpenDays: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        willCallOpenDays: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        operationFromTime: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        operationToTime: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        willCallFromTime: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
        willCallToTime: Yup.string().required(validationMessages.required).max(25, "The value must be no more than 25 characters"),
    })
}

export const statusOptions: XGSSelectOption[] = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
];


export const terminalTypeOptions = [
    { label: "XGS Terminal", value: "XGS Terminal" },
    { label: "Agent Terminal", value: "Agent Terminal" },
    { label: "WG Locations", value: "WG Locations" },
];

export const divisionOptions: XGSSelectOption[] = [
    { label: "Air Cargo", value: "Air Cargo" },
    { label: "Floor Covering", value: "Floor Covering" },
    { label: "Both", value: "Both" },
];

export const timezoneOptions: XGSSelectOption[] = [
    { label: "Central (CST)", value: "CST" },
    { label: "Eastern (EST)", value: "EST" },
    { label: "Atlantic (AST)", value: "AST" },
    { label: "Alaskan (KST)", value: "KST" },
    { label: "Mountain (MST)", value: "MST" },
    { label: "Newfoundland (NST)", value: "NST" },
    { label: "Pacific (PST)", value: "PST" },
];

export const WMSWarehousingOptions: XGSSelectOption[] = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
];

export const operationDaysOptions: XGSSelectOption[] = [
    { label: "Monday-Friday", value: "Monday-Friday" },
    { label: "Monday-Sunday", value: "Monday-Sunday" },
];

export const countryOptions = [
    { label: "United States", value: "USA" },
    { label: "Canada", value: "CAN" },
    { label: "Mexico", value: "MEX" },

];

export interface UpdateTerminalName {
    terminalNumber: number;
    terminalName: string;
}
